<footer class="mt-5">
  <div class="row">
    <div class="col">
      <strong>Deutsche Post DHL Group</strong>
    </div>
  </div>
  <div class="row mt-3 text-center">

    <div class="col-12 col-md-2 mt-3 d-flex justify-content-center">
      <a href="https://www.dhl.com/content/dam/dhl/local/mx/core/documents/pdf/mx-core-legal-aviso-de-privacidad-integral-dhl-express-mexico-local-ES.pdf " target="_blank" rel="noopener noreferrer" style="color: #333333;"><h6>Aviso de Privacidad</h6></a>
    </div>
    <div class="col-12 col-md-2 mt-3 d-flex justify-content-center">
      <a (click)="redirectToTerms()" style="color: #333333; text-decoration: underline;">
        <h6>Términos de Uso</h6>
      </a>
    </div>
    <div class="col-12 col-md-2 mt-3 d-flex justify-content-center">
      <a href="https://www.dhl.com/mx-es/home/pie-de-pagina/aviso-legal.html" target="_blank" style="color: #333333;"><h6>Aviso legal</h6></a>
    </div>
    <div class="col-12 col-md-4 mt-3 d-flex justify-content-center ">
      <a href="https://mydhl.express.dhl/mx/es/legal/terms-and-conditions.html" target="_blank" style="color: #333333;"><h6>Términos y Condiciones de Transporte de DHL Express</h6></a>
    </div>

    <div class="col-12 col-md-2 mt-3">
      <div class="row">
        <div class="col text-center">
          <strong>Síguenos en</strong>
        </div>
      </div>
      <div class="container text-center">
        <div class="row align-items-center">
          <div class="col-3 col-md-3">
            <a href="https://twitter.com/DHLMex" target="_blank">
              <em><button mat-icon-button color="primary">
                  <img [src]="imagenShowtwiter" alt="twiter" />
                </button></em>
            </a>
          </div>
          <div class="col-3 col-md-3">
            <a href="https://www.linkedin.com/company/dhl-express-mexico/" target="_blank">
              <em><button mat-icon-button color="primary">
                  <img [src]="imagenShowlinkeding" alt="linkeding" />
                </button></em>
            </a>
          </div>
          <div class="col-3 col-md-3">
            <a href="https://www.instagram.com/dhlmex/" target="_blank">
              <em><button mat-icon-button color="primary">
                  <img  [src]="imagenShowinstagram" alt="instagram"/>
                </button></em>
            </a>
          </div>
          <div class="col-3 col-md-3">
            <a href="https://www.youtube.com/user/DHLMexicoOficial" target="_blank">
              <em><button mat-icon-button color="primary">
                  <img [src]="imagenShowfacebook" alt="youtobe" />
                </button></em>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>


  <div class="row mt-3">
    <div class="col">
      <p>{{ date.getFullYear() }} © DHL Internacional GmbH. Todos los derechos reservados.</p>
    </div>
  </div>
</footer>
